import { inject, Injectable } from '@angular/core';

import { DepositListBloc } from '@connect-services/client/blocs/deposit-list.bloc';
import { FieldInterventionBloc } from '@connect-services/client/blocs/field-intervention.bloc';
import { FieldInterventionEntitiesListBloc } from '@connect-services/client/blocs/field-intervention-entities-list.bloc';
import { FieldInterventionEntityBloc } from '@connect-services/client/blocs/field-intervention-entity.bloc';
import { FieldInterventionListBloc } from '@connect-services/client/blocs/field-intervention-list.bloc';
import { LayerBloc } from '@connect-services/client/blocs/layer.bloc';
import { LayerEntityBloc } from '@connect-services/client/blocs/layer-entity.bloc';
import { LayerListBloc } from '@connect-services/client/blocs/layer-list.bloc';
import { PeopleListBloc } from '@connect-services/client/blocs/people-list.bloc';
import { PermissionListBloc } from '@connect-services/client/blocs/permission-list.bloc';
import { ProjectBloc } from '@connect-services/client/blocs/project.bloc';
import { ProjectListBloc } from '@connect-services/client/blocs/project-list.bloc';
import { RoleListBloc } from '@connect-services/client/blocs/role-list.bloc';

type BlocTypes =
    | DepositListBloc
    | FieldInterventionBloc
    | FieldInterventionEntityBloc
    | FieldInterventionEntitiesListBloc
    | FieldInterventionListBloc
    | LayerBloc
    | LayerEntityBloc
    | LayerListBloc
    | PeopleListBloc
    | PermissionListBloc
    | ProjectBloc
    | ProjectListBloc
    | RoleListBloc;

@Injectable({
    providedIn: 'root',
})
export class BlocManagerService {
    private blocs!: BlocTypes[];
    private readonly depositListBloc = inject(DepositListBloc);
    private readonly fieldInterventionBloc = inject(FieldInterventionBloc);
    private readonly fieldInterventionEntitiesListBloc = inject(FieldInterventionEntitiesListBloc);
    private readonly fieldInterventionEntityBloc = inject(FieldInterventionEntityBloc);
    private readonly fieldInterventionListBloc = inject(FieldInterventionListBloc);
    private readonly layerBloc = inject(LayerBloc);
    private readonly layerEntityBloc = inject(LayerEntityBloc);
    private readonly layerListBloc = inject(LayerListBloc);
    private readonly peopleListBLoc = inject(PeopleListBloc);
    private readonly permissionListBloc = inject(PermissionListBloc);
    private readonly projectBloc = inject(ProjectBloc);
    private readonly projectListBloc = inject(ProjectListBloc);
    private readonly roleListBloc = inject(RoleListBloc);

    public constructor() {
        this.setBlocs();
    }

    public resetBlocs(): void {
        this.blocs.forEach((bloc: BlocTypes) => {
            if (!bloc) {
                return;
            }
            bloc.reset();
        });
    }

    private setBlocs(): void {
        this.blocs = [
            this.projectBloc,
            this.layerEntityBloc,
            this.layerListBloc,
            this.depositListBloc,
            this.fieldInterventionBloc,
            this.fieldInterventionEntitiesListBloc,
            this.fieldInterventionEntityBloc,
            this.fieldInterventionListBloc,
            this.layerBloc,
            this.permissionListBloc,
            this.peopleListBLoc,
            this.projectListBloc,
            this.roleListBloc,
        ];
    }
}
